import React from "react";
import "./Caelus1.scss";
import data from "./data.json";
import Card from "../../../Component/Card/card";
import Caelus8images from "../../../Media/BSD/Caelus/Caelus8";
import Caelus9images from "../../../Media/BSD/Caelus/Caelus9";
import Caelus10images from "../../../Media/BSD/Caelus/Caelus10";

const imageMap = {
  Caelus8images,
  Caelus9images,
  Caelus10images,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Briza" className="produk">
      <h1>Our Home</h1>
      <h2>Cicilan Start 32 Juta/Bulan</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
